import React from 'react';
import 'styles/chat/RightFloatingChat.css';
import RightChatPanel from 'components/chat/RightChatPanel';

const RightFloatingBubble = ({onClose}) => {
    return (
        <div className={`side-content`}>
            <div className="chat-bubble-container">
                <RightChatPanel
                    onClose={onClose}
                />
            </div>
        </div>
    );
};

export default RightFloatingBubble;
